namespace RedBullMOBILE360.CustomerCare {
    export interface ManualResumeFraudCasesExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ManualResumeFraudCasesExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.ManualResumeFraudCasesExcelImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ManualResumeFraudCasesExcelImportForm.init)  {
                ManualResumeFraudCasesExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ManualResumeFraudCasesExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
